import { createContext, useContext, useEffect, useState } from "react";

const ConfigContext = createContext(null);

export const HEADING_FONTS = ["Fredoka", "Baloo 2", "Nunito", "Outfit", "Poppins", "Playfair Display"];
export const BODY_FONTS = ["Plus Jakarta Sans", "Nunito Sans", "Lato", "Source Sans 3", "DM Sans"];

const loadFont = (family) => {
  const id = `font-${family.replace(/\s+/g, "-")}`;
  if (!family || document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/\s+/g, "+")}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
};

export const applyBrand = (cfg) => {
  const root = document.documentElement.style;
  const hex = (v, d) => (/^#[0-9a-f]{6}$/i.test(v || "") ? v : d);
  root.setProperty("--brand", hex(cfg?.primary_color, "#6B21A8"));
  root.setProperty("--brand-accent", hex(cfg?.accent_color, "#F59E0B"));
  const heading = cfg?.heading_font || "Fredoka";
  const body = cfg?.body_font || "Plus Jakarta Sans";
  loadFont(heading);
  loadFont(body);
  root.setProperty("--font-display", `"${heading}"`);
  root.setProperty("--font-body", `"${body}"`);
};

export function ConfigProvider({ initial, slug, children }) {
  const [config, setConfig] = useState(initial);

  useEffect(() => { setConfig(initial); }, [initial]);
  useEffect(() => {
    applyBrand(config);
    if (config) document.title = `${config.institute_name} — Admissions`;
  }, [config]);

  return <ConfigContext.Provider value={{ config, setConfig, slug }}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext) || {};
